export const interopTestSuffix = () => (window.location.href.indexOf('-interoptest') !== -1 ? '-interoptest' : '');
